// extracted by mini-css-extract-plugin
export var spark_callout = "spark_callout-Q6K";
export var spark_callout_content = "spark_callout_content-YQh";
export var spark_image = "spark_image-YQj";